/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.MetaData = factory(root.BpmbuildProductionappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The MetaData model module.
   * @module model/MetaData
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>MetaData</code>.
   * @alias module:model/MetaData
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>MetaData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MetaData} obj Optional instance to populate.
   * @return {module:model/MetaData} The populated <code>MetaData</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('extraProperty'))
        obj.extraProperty = ApiClient.convertToType(data['extraProperty'], 'String');
      if (data.hasOwnProperty('cardBean'))
        obj.cardBean = ApiClient.convertToType(data['cardBean'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} extraProperty
   */
  exports.prototype.extraProperty = undefined;

  /**
   * @member {String} cardBean
   */
  exports.prototype.cardBean = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/MetaData.js